import React, {Component, CSSProperties} from 'react';

interface componentProps {
    strokeColor?: string;
}

interface componentStates extends componentProps {}

class BackArrowIcon extends Component<componentProps,componentStates> {

    constructor(props:componentProps) {
        super(props);
        this.state = {
            strokeColor: "#000"
        }
    }

    componentDidMount() {
        if(this.props.strokeColor) {
            this.setState({
                strokeColor: this.props.strokeColor
            });
        }
    }

    render() {

        const { strokeColor } = this.state;
        
        const cls1: CSSProperties = {
            stroke: strokeColor
        }

        return (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="https://www.w3.org/2000/svg">
                <title>Back</title>
                <path d="M10.5 16L6 12M6 12L10.5 8M6 12H18" style={cls1} strokeLinecap="round" strokeLinejoin="round"/>
            </svg>

        )
    }
}

export default BackArrowIcon;